import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Search, Close } from '../../../assets/images';
const RecentSearch = props => {
    const [searchValue, setSearchValue] = useState('');

    const searchFilterList = e => {
        const { value } = e.target;
        if (value.trim().length === 0) {
            setSearchValue(value);
            props.search('');
        } else {
            setSearchValue(value);
            props.search(value);
        }
    };

    const resetInputField = () => {
        setSearchValue('');
        props.search('');
    };

    return (
        <div className={`search-container ${props.customClass || ''} ${searchValue && 'typingValue'}`}>
            <div className="search">
                {!searchValue && <Search className="search-icon" />}
                <input
                    type="text"
                    className="search-contacts"
                    name="search-contacts"
                    autoComplete="off"
                    placeholder={`${props.placeHolder || 'Search'}`}
                    value={searchValue}
                    onChange={searchFilterList}
                />
                <i
                    className="CloseSearch"
                    onClick={resetInputField}
                    onKeyDown={e => e.key === 'Enter' && resetInputField}
                    tabIndex="0"
                    role="button"
                >
                    {searchValue && <Close />}
                </i>
            </div>
        </div>
    );
};
export default RecentSearch;

RecentSearch.propTypes = {
    search: PropTypes.func,
};
